import { Bijection } from "./bijection";

const HEX_BASE = 16;
const hex: string[] = [];
for (let i = 0; i < HEX_BASE * HEX_BASE; i++) {
  hex[i] = i.toString(HEX_BASE).padStart(2, "0");
}

export const base64StringEncoding: Bijection<string, string> = {
  read(string) {
    return atob(string);
  },
  write(value) {
    return btoa(value);
  },
};

export const base64Encoding: Bijection<string, ArrayBuffer> = {
  read(string) {
    const base64 = atob(string);
    return new Uint8Array(new TextEncoder().encode(base64)).buffer;
  },
  write(value) {
    const base64 = new TextDecoder().decode(value);
    return btoa(base64);
  },
};

export const hexEncoding: Bijection<string, ArrayBuffer> = {
  read(string) {
    if (typeof Buffer !== "undefined") {
      return new Uint8Array(Buffer.from(string, "hex")).buffer;
    }
    const buffer = new ArrayBuffer(string.length / 2);
    const data = new Uint8Array(buffer);
    for (let i = 0; i < data.length; i++) {
      data[i] = parseInt(string.slice(i * 2, (i + 1) * 2), HEX_BASE);
    }
    return buffer;
  },
  write(data) {
    if (typeof Buffer !== "undefined") {
      return Buffer.from(data).toString("hex");
    }
    const ints = new Uint8Array(data);
    let result = "";
    for (const int of ints) {
      result += hex[int];
    }
    return result;
  },
};

export const latin1Encoding: Bijection<ArrayBuffer, string> = {
  read(data) {
    return new TextDecoder("latin1").decode(data);
  },
  write(string) {
    if (typeof Buffer !== "undefined") {
      return new Uint8Array(Buffer.from(string, "binary")).buffer;
    }
    const buffer = new ArrayBuffer(string.length * 2);
    const data = new Uint16Array(buffer);
    for (let index = 0; index < string.length; index++) {
      data[index * 2] = string.charCodeAt(index);
    }
    return buffer;
  },
};

export const utf8Encoding: Bijection<ArrayBuffer, string> = {
  read(data) {
    return new TextDecoder().decode(data);
  },
  write(string) {
    return new TextEncoder().encode(string).buffer;
  },
};
